import request from '@/utils/request'

// 查询企业点赞用户列表
export function listUserFirm(query) {
  return request({
    url: '/h5/userFirm/list',
    method: 'get',
    params: query
  })
}

// 查询企业点赞用户详细
export function getUserFirm(id) {
  return request({
    url: '/user/userFirm/' + id,
    method: 'get'
  })
}

// 新增企业点赞用户
export function addUserFirm(data) {
  return request({
    url: '/h5/userFirm',
    method: 'post',
    data: data
  })
}

// 修改企业点赞用户
export function updateUserFirm(data) {
  return request({
    url: '/user/userFirm',
    method: 'put',
    data: data
  })
}

// 删除企业点赞用户
export function delUserFirm(id) {
  return request({
    url: '/user/userFirm/' + id,
    method: 'delete'
  })
}
